import {Box} from '@dagster-io/ui-components';
import {ReactNode} from 'react';

import DagsterPlusLogo from '@/components/DagsterPlusLogo';
import styles from '@/components/css/CenteredMain.module.css';

export default function CenteredMain({children}: {children: ReactNode}) {
  return (
    <Box
      flex={{direction: 'column', justifyContent: 'center', alignItems: 'center', gap: 36}}
      className={styles.container}
    >
      <Box style={{height: 40}} margin={{vertical: 12}}>
        <DagsterPlusLogo />
      </Box>
      {children}
    </Box>
  );
}
